import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getFormValues } from 'redux-form';

import { Filter, Main } from 'Containers/';
import { DEFAULT_LABOR_HOURS_FORM_NAME } from 'Common/FormEnum';
import { DefaultLaborHoursFieldEnum as Fields } from 'Common/FieldEnum';
import { getFiscalYearsAction } from 'State/fiscalYears/actions';
import * as CommonStateSelectors from 'State/selectors';
import { getFiscalYear } from 'Common/GeneralHelper';
import { createToast, toastType, errorToast } from 'Common/ToastHelper';

import { DefaultLaborHoursForm } from './components/DefaultLaborHoursForm';
import * as actions from './state/actions';
import * as selectors from './state/selectors';

class DefaultLaborHoursContainer extends Component {
  currentFiscalYear = getFiscalYear(new Date());

  getMainProps = () => {
    const { loading } = this.props;
    return {
      toolbox: {
        formName: DEFAULT_LABOR_HOURS_FORM_NAME,
        saveButtonProps: {
          content: 'Save',
          loading: loading,
          disabled: loading,
        },
        shown: true,
      },
    };
  };

  buildFiscalYears = () => {
    return this.props.fiscalYears.map((element, index) => {
      return {
        key: index,
        value: element,
        text: element.toString(),
      };
    });
  };

  componentDidMount() {
    const { getFiscalYearsAction, getDefaultLaborHourSites } = this.props;
    getFiscalYearsAction();
    getDefaultLaborHourSites(this.currentFiscalYear);
  }

  componentDidUpdate(prevProps) {
    const {
      saveSuccessful,
      setSaveSuccessful,
      getDefaultLaborHourSites,
      clearErrors,
      formValues,
    } = this.props;
    if (
      prevProps.saveSuccessful !== saveSuccessful &&
      saveSuccessful === true
    ) {
      createToast(toastType.success, 'Success', 'Saved Successfully');
      setSaveSuccessful(false);
      getDefaultLaborHourSites(formValues.FiscalYear);
    }

    if (
      errorToast(this.props, prevProps, 'fetchError') ||
      errorToast(this.props, prevProps, 'saveError')
    ) {
      clearErrors();
    }
  }

  handleSubmit = (formValues) => {
    const { saveDefaultLaborHours } = this.props;

    saveDefaultLaborHours(formValues);
  };

  handleFiscalYearChange = (e, newValue) => {
    const { getDefaultLaborHourSites } = this.props;
    getDefaultLaborHourSites(newValue);
  };

  render() {
    const { sites, loading } = this.props;

    return (
      <Fragment>
        <Filter title={'Default Labor Hours'} />
        <Main {...this.getMainProps()}>
          <DefaultLaborHoursForm
            onSubmit={this.handleSubmit}
            fiscalYearOptions={this.buildFiscalYears()}
            handleFiscalYearChange={this.handleFiscalYearChange}
            loading={loading}
            sites={sites}
            initialValues={{
              [Fields.DefaultLaborHours]: '0.00',
              [Fields.FiscalYear]: this.currentFiscalYear,
            }}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    fiscalYears: CommonStateSelectors.getFiscalYears(state),
    fetchLoading: selectors.getFetchLoading(state),
    saveLoading: selectors.getSaveLoading(state),
    saveSuccessful: selectors.getSaveSuccessful(state),
    sites: selectors.getSites(state),
    formValues: getFormValues(DEFAULT_LABOR_HOURS_FORM_NAME)(state),
    loading:
      selectors.getFetchLoading(state) || selectors.getSaveLoading(state),
  };
};

const mapDispatchToProps = { ...actions, getFiscalYearsAction };

export const DefaultLaborHours = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DefaultLaborHoursContainer)
);



// WEBPACK FOOTER //
// ./src/pages/defaultlaborhours/DefaultLaborHours.js